/* RESPONSIBLE TEAM: team-knowledge-foundations */

import BaseListController from 'embercom/controllers/apps/app/articles/articles/list/base';

export default class ViewsArticlesListController extends BaseListController {}
